import 'Vendors/outdatedbrowser/outdatedbrowser.js';
import './blocks/video-slideshow.js';

$(function() {
    $('.navigation-toggle').on('click', function(e) {
        e.preventDefault();
        $('body').toggleClass('menu-open');
    });

    $('a').on('click', function(e) {
        const $this = $(e.currentTarget);
        const url = $this.attr('href');
        if (url.indexOf("#") >= 0 && !$('body').hasClass('page-edit-mode')) {
            e.preventDefault();
            $('html,body').animate({
                scrollTop: $(url).offset().top
            }, 1200);
            $('body').removeClass('menu-open');
        }
    });
})


$(window).on('load', function() {
    $('body').addClass('loaded');
});

$(window).on('scroll', function () {
    const scrollDistance = $(window).scrollTop();
    if (scrollDistance > 50) {
        $('body').addClass('scrolled');
    } else {
        $('body').removeClass('scrolled');
    }
});
